import _ from 'lodash';

export const getObjectName = (option) => _.get(option, 'name');
